const DashedLine = ({ className }: { className?: string }) => (
  <div
    className={`my-[5px] mx-0 bg-dashed-line h-[1px] w-full ${className}`}
  ></div>
);
export default DashedLine;
